import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Icon } from "semantic-ui-react";

import { useCan } from "components";
import { ThreeDepartmentModal } from "modules/AppointmentDetails/components/ThreeDepartment/components/ThreeDepartmentModal";
import "modules/AppointmentDetails/components/ThreeDepartment/ThreeDepartment.scss";
import { isThreeDepartmentEditable } from "utils/appointmentUtils";

import type { Appointment } from "models";

type ThreeDepartmentIconsProps = {
  appointment: Appointment;
  disabled: boolean;
  onClick: () => void;
};

const ThreeDepartmentIcons = ({ appointment, disabled, onClick }: ThreeDepartmentIconsProps) => {
  const { t } = useTranslation();

  return (
    <div
      className={`ThreeDepartmentOverview ${disabled ? "disabled" : ""}`}
      onClick={() => {
        if (disabled) return;
        onClick();
      }}
    >
      <span className="label">{t("v8_three_department_short", "3D")}</span>

      <div className="department">
        <Icon className={`${appointment.three_department_receptionist ? "check circle status checked" : "circle xmark status unchecked"}`} />
        <Icon className="user" />
      </div>
      <div className="department">
        <Icon className={`${appointment.three_department_parts ? "check circle status checked" : "circle xmark status unchecked"}`} />
        <Icon className="gear" />
      </div>
      <div className="department">
        <Icon className={`${appointment.three_department_workshop ? "check circle status checked" : "circle xmark status unchecked"}`} />
        <Icon className="wrench" />
      </div>
    </div>
  );
};

type ThreeDepartmentOverviewProps = {
  appointment: Appointment;
};

export const ThreeDepartmentOverview = ({ appointment }: ThreeDepartmentOverviewProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const canUpdate = useCan("update", "appointments-three-departments");

  return (
    <>
      <ThreeDepartmentIcons appointment={appointment} disabled={!canUpdate} onClick={() => setIsOpen(true)} />

      {canUpdate && isOpen && <ThreeDepartmentModal appointment={appointment} readOnly={!isThreeDepartmentEditable(appointment)} onClose={() => setIsOpen(false)} />}
    </>
  );
};
